module.exports = "/wwwroot/img/footer-drops.svg?ver=1954e661";